require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.array.fill");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.array.fill");

module.exports = /*#__PURE__*/function () {
  "use strict";

  function Spline(xs, ys) {
    this.xs = xs;
    this.ys = ys;
    this.ks = this.getNaturalKs(new Array(this.xs.length).fill(0));
  }

  var _proto = Spline.prototype;

  _proto.getNaturalKs = function getNaturalKs(ks) {
    var n = this.xs.length - 1;
    var A = zerosMat(n + 1, n + 2);

    for (var i = 1; i < n; i++ // rows
    ) {
      A[i][i - 1] = 1 / (this.xs[i] - this.xs[i - 1]);
      A[i][i] = 2 * (1 / (this.xs[i] - this.xs[i - 1]) + 1 / (this.xs[i + 1] - this.xs[i]));
      A[i][i + 1] = 1 / (this.xs[i + 1] - this.xs[i]);
      A[i][n + 1] = 3 * ((this.ys[i] - this.ys[i - 1]) / ((this.xs[i] - this.xs[i - 1]) * (this.xs[i] - this.xs[i - 1])) + (this.ys[i + 1] - this.ys[i]) / ((this.xs[i + 1] - this.xs[i]) * (this.xs[i + 1] - this.xs[i])));
    }

    A[0][0] = 2 / (this.xs[1] - this.xs[0]);
    A[0][1] = 1 / (this.xs[1] - this.xs[0]);
    A[0][n + 1] = 3 * (this.ys[1] - this.ys[0]) / ((this.xs[1] - this.xs[0]) * (this.xs[1] - this.xs[0]));
    A[n][n - 1] = 1 / (this.xs[n] - this.xs[n - 1]);
    A[n][n] = 2 / (this.xs[n] - this.xs[n - 1]);
    A[n][n + 1] = 3 * (this.ys[n] - this.ys[n - 1]) / ((this.xs[n] - this.xs[n - 1]) * (this.xs[n] - this.xs[n - 1]));
    return solve(A, ks);
  };

  _proto.at = function at(x) {
    var i = 1;

    while (this.xs[i] < x) {
      i++;
    }

    var t = (x - this.xs[i - 1]) / (this.xs[i] - this.xs[i - 1]);
    var a = this.ks[i - 1] * (this.xs[i] - this.xs[i - 1]) - (this.ys[i] - this.ys[i - 1]);
    var b = -this.ks[i] * (this.xs[i] - this.xs[i - 1]) + (this.ys[i] - this.ys[i - 1]);
    var q = (1 - t) * this.ys[i - 1] + t * this.ys[i] + t * (1 - t) * (a * (1 - t) + b * t);
    return q;
  };

  return Spline;
}();

function solve(A, ks) {
  var m = A.length;

  for (var k = 0; k < m; k++ // column
  ) {
    // pivot for column
    var i_max = 0;
    var vali = Number.NEGATIVE_INFINITY;

    for (var i = k; i < m; i++) {
      if (A[i][k] > vali) {
        i_max = i;
        vali = A[i][k];
      }
    }

    swapRows(A, k, i_max); // for all rows below pivot

    for (var _i = k + 1; _i < m; _i++) {
      for (var j = k + 1; j < m + 1; j++) {
        A[_i][j] = A[_i][j] - A[k][j] * (A[_i][k] / A[k][k]);
      }

      A[_i][k] = 0;
    }
  }

  for (var _i2 = m - 1; _i2 >= 0; _i2-- // rows = columns
  ) {
    var v = A[_i2][m] / A[_i2][_i2];
    ks[_i2] = v;

    for (var _j = _i2 - 1; _j >= 0; _j-- // rows
    ) {
      A[_j][m] -= A[_j][_i2] * v;
      A[_j][_i2] = 0;
    }
  }

  return ks;
}

function zerosMat(r, c) {
  var A = [];

  for (var i = 0; i < r; i++) {
    A.push([]);

    for (var j = 0; j < c; j++) {
      A[i].push(0);
    }
  }

  return A;
}

function swapRows(m, k, l) {
  var p = m[k];
  m[k] = m[l];
  m[l] = p;
}